export default function hoverVideo() {
    document.querySelectorAll('.js-hover-video')?.forEach(card => {
        const video = card.querySelector('video');
        //const img = card.querySelector('img');

        if (window.innerWidth <= 530 || !video) return;

        let isHover = false;
        card.addEventListener('mouseenter', () => {
            isHover = true;
            //img.style.opacity = '0';
            video.style.opacity = '1';

            video.currentTime = 0;
            video.play();
        });

        card.addEventListener('mouseleave', () => {
            isHover = false;
            video.pause();
            video.currentTime = 0;

            //img.style.opacity = '1';
            //video.style.opacity = '0';
        });

        video.addEventListener('ended', () => {
            if (isHover) {
                //img.style.opacity = '1';
                //video.style.opacity = '0';
            }
        });
    });
}
